// Please, do not create analytics events here
// Use the protobuf event repository instead
// packages/core/src/protos/events/so5/web/events.ts
// packages/core/src/protos/events/so5/shared/events.ts
// We will slowly migrate all self-defined events to the protobuf repository

import { generateUseEvents } from '@sorare/core/src/lib/events/generateUseEvents';
import {
  Sport,
  sportToJSON,
} from '@sorare/core/src/protos/events/shared/events';

type AnySportEventTypes = {
  'Open Match Center Appearance Details': {
    playerSlug: string;
  };
  'Open Match View': {
    gameId: string;
    gameStatus?: string;
    deviceType: string;
    interactionContext?: 'match_view' | 'match_center' | 'appearance_dialog';
  };
  'Open Match View Appearance Details': {
    playerSlug: string;
  };
  'Open Match View Player Details Drawer': {
    playerSlug: string;
  };
  'Navigate To Player Page': {
    playerSlug: string;
    interactionContext?: 'player_details_drawer';
  };
  'View Shared Lineup': {
    lineup: string;
    competition: string;
  };
  'Select Player In First Compose Team': {
    position?: string;
  };
  'Click Market In First Compose Team': void;
  'Click Roster In First Compose Team': void;
  'View Onboarding Welcome': void;
  'View Onboarding Score Points': void;
  'View Onboarding Chase Glory': void;
  'View Onboarding Compare Scores': void;
  'View Onboarding Build your club': void;
  'View Onboarding Select star player': void;
  'Click Onboarding Select star player': {
    player: string;
  };
  'View Onboarding Star signing': void;
  'View Onboarding Pick favorite team': void;
  'Click Onboarding Pick favorite team': {
    team: string;
  };
  'View Onboarding Starter pack': void;
  'View Onboarding Starter pack content': void;
  'Click close Onboarding': void;
  'View Choose Your Level Page': void;
  'View Go Pro Screen': void;
  'View Tutorial Page': void;
  'View Choose Competition Page': void;
  'View Choose Teams Page': void;
};

type FootballEventTypes = AnySportEventTypes & {
  'Enter General Tutorial': void;
  'Click Next In General Tutorial': {
    step: 'Score Points' | 'League Details' | 'Win Prizes';
  };
  'Enter Add Team From Lobby': {
    source: 'Your Next Step';
  };
  'Click Continue after Pack Opening': void;
};

export const useFootballEvents = generateUseEvents<FootballEventTypes>({
  defaultProperties: {
    sport: sportToJSON(Sport.FOOTBALL),
  },
});

export const useAnySportEvents = generateUseEvents<AnySportEventTypes>();
